<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("legal.menu.socials") }} </template>

        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <p class="ct-text">
                    {{ $t("legal.socials.info") }}
                </p>
                <div class="space-y-3">
                    <SocialCard
                        v-for="social in socials"
                        :key="social.title"
                        :social="social"
                        @toggleEnabled="social.toggleEnabled"
                        @click="editSocial(social)"
                        @edit="editSocial(social)"
                    />
                </div>
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { markRaw } from "vue";
import { mapState, mapActions } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import {
    FacebookIcon,
    TwitterIcon,
    YoutubeIcon,
    LinkedinIcon,
    InstagramIcon,
    GithubIcon,
    DribbleIcon,
} from "@easy/ui/icons";
import SocialCard from "./SocialCard.vue";
import { useSaveOrDropModal } from "@/store/useSaveOrDropModal";
import cSaveButton from "@/shared/components/cSaveButton.vue";

export default {
    components: {
        PageSidebar,
        SocialCard,
        cSaveButton,
    },
    emits: ["edit", "add"],
    setup() {
        return useSaveOrDropModal();
    },
    computed: {
        ...mapState("legal", ["footer", "hasChanges"]),
        socials() {
            return [
                {
                    predefined: true,
                    title: "Facebook",
                    icon: markRaw(FacebookIcon),
                    enabled: this.footer.fb,
                    url: this.footer.fbUrl,
                    changeUrl: (url) => {
                        this.footer.fbUrl = url;
                    },
                    changeEnabled: (state) => {
                        this.footer.fb = state;
                    },
                    toggleEnabled: () => {
                        this.footer.fb = !this.footer.fb;
                    },
                },
                {
                    predefined: true,
                    title: "X (Twitter)",
                    icon: markRaw(TwitterIcon),
                    enabled: this.footer.twitter,
                    url: this.footer.twitterUrl,
                    changeUrl: (url) => {
                        this.footer.twitterUrl = url;
                    },
                    changeEnabled: (state) => {
                        this.footer.twitter = state;
                    },
                    toggleEnabled: () => {
                        this.footer.twitter = !this.footer.twitter;
                    },
                },
                {
                    predefined: true,
                    title: "Youtube",
                    icon: markRaw(YoutubeIcon),
                    enabled: this.footer.youtube,
                    url: this.footer.youtubeUrl,
                    changeUrl: (url) => {
                        this.footer.youtubeUrl = url;
                    },
                    changeEnabled: (state) => {
                        this.footer.youtube = state;
                    },
                    toggleEnabled: () => {
                        this.footer.youtube = !this.footer.youtube;
                    },
                },
                {
                    predefined: true,
                    title: "Linkedin",
                    icon: markRaw(LinkedinIcon),
                    enabled: this.footer.linkedin,
                    url: this.footer.linkedinUrl,
                    changeUrl: (url) => {
                        this.footer.linkedinUrl = url;
                    },
                    changeEnabled: (state) => {
                        this.footer.linkedin = state;
                    },
                    toggleEnabled: () => {
                        this.footer.linkedin = !this.footer.linkedin;
                    },
                },
                {
                    predefined: true,
                    title: "Instagram",
                    icon: markRaw(InstagramIcon),
                    enabled: this.footer.ig,
                    url: this.footer.igUrl,
                    changeUrl: (url) => {
                        this.footer.igUrl = url;
                    },
                    changeEnabled: (state) => {
                        this.footer.ig = state;
                    },
                    toggleEnabled: () => {
                        this.footer.ig = !this.footer.ig;
                    },
                },
                {
                    predefined: true,
                    title: "GitHub",
                    icon: markRaw(GithubIcon),
                    enabled: this.footer.gh,
                    url: this.footer.ghUrl,
                    toggleEnabled: () => {
                        this.footer.gh = !this.footer.gh;
                    },
                },
                {
                    predefined: true,
                    title: "Dribble",
                    icon: markRaw(DribbleIcon),
                    enabled: this.footer.dribble,
                    url: this.footer.dribbleUrl,
                    changeUrl: (url) => {
                        this.footer.dribbleUrl = url;
                    },
                    changeEnabled: (state) => {
                        this.footer.dribble = state;
                    },
                    toggleEnabled: () => {
                        this.footer.dribble = !this.footer.dribble;
                    },
                },
            ];
        },
    },
    methods: {
        ...mapActions("legal/projects", ["saveSnapshot", "loadProject"]),
        async editSocial(social) {
            await this.askToConfirmIfNeeded({
                showModal: this.hasChanges,
                onConfirmChanges: async () => this.saveSnapshot(),
                onDropChanges: async () => this.loadProject(this.footer.uuid),
            });
            this.$emit("edit", social);
        },
    },
};
</script>
